import React from "react"
import { Link } from "gatsby"
import "./Footer.scss"
import LrtLogo from "../../assets/svg/lrt-wh.svg"
import MmoLogo from "../../assets/svg/Group 31.svg"

import iqLogo from "../../assets/images/png/iq.png"
import luminorLogo from "../../assets/images/png/luminor.png"
import margaritaLogo from "../../assets/images/png/margarita.png"
import smsmLogo from "../../assets/images/png/smsm.png"
import teliaLogo from "../../assets/images/png/telia.png"
import erasmusLogo from "../../assets/images/png/erasmusplus.png"

import FbLogo from "../../assets/svg/facebook.svg"
import LongArrowRight from "../../assets/svg/long-arrow-right.svg"

export default () => (
  <footer className="footer">
    <div className="container">
      <div>Organizers</div>

      <div className="footer--organisators">
        <a
          href="https://lrt.lt"
          rel="noopener noreferrer"
          target="_blank"
          title="LRT"
        >
          <img height="72px" src={LrtLogo} alt="LRT" />
        </a>
        <a
          href="https://www.llri.lt/"
          rel="noopener noreferrer"
          target="_blank"
          title="LLRI"
        >
          <img src={MmoLogo} alt="LLRI" />
        </a>
      </div>


      <div>Project patron</div>
      <div className="footer--organisators">
        <a
          href="https://smsm.lrv.lt/"
          rel="noopener noreferrer"
          target="_blank"
          title="Švietimo, mokslo ir sporto ministerija"
        >
          <img src={smsmLogo} alt="Švietimo, mokslo ir sporto ministerija" style={{maxWidth:150}} />
        </a>
      </div>


      <div>Sponsors</div>
      <div className="footer--organisators" style={{flexWrap:"wrap", rowGap:15}} >
        <a
          href="https://www.margarita.eu/"
          rel="noopener noreferrer"
          target="_blank"
          title="Margarita"
        >
          <img src={margaritaLogo} alt="Margarita" style={{maxWidth:90}} />
        </a>
        <a
          href="https://www.telia.lt/"
          rel="noopener noreferrer"
          target="_blank"
          title="Telia"
        >
          <img src={teliaLogo} alt="Telia" style={{maxWidth:120}}/>
        </a>
        <a
          href="https://iq.lt/"
          rel="noopener noreferrer"
          target="_blank"
          title="IQ"
        >
          <img src={iqLogo} alt="IQ" style={{maxWidth:80}}/>
        </a>
        <a
          href="https://www.luminor.lt/"
          rel="noopener noreferrer"
          target="_blank"
          title="Luminor"
        >
          <img src={luminorLogo} alt="Luminor" style={{maxWidth:150}} />
        </a>

        <a
          href="https://erasmus-plus.ec.europa.eu/"
          rel="noopener noreferrer"
          target="_blank"
          title="Erasmus+"
        >
          <img src={erasmusLogo} alt="Erasmus+" style={{maxWidth:160}} />
        </a>


      </div>

      {/*
      <div className="footer--socials">
        <img src={LongArrowRight} alt="" />

        <a
          href="https://www.facebook.com/events/772006927029270/"
          target="_blank"
          rel="noopener noreferrer"
          title="Facebook"
        >
          <img src={FbLogo} alt="Facebook" />
        </a>
      </div>
      */}

      <div className="dn-mobile">
        <Link to="/privacy-policy" title="Privacy policy">
          Privacy policy
        </Link>
      </div>


    </div>
  </footer>
)
